import { IntField } from '@ff-it/form';
import { ItemLoader, UpdateContainer, useEntity, withHasPerm } from 'components';
import { platformAdmin } from 'core/permissions';
import { Enterprise } from 'modules/core/types';
import { ReactElement } from 'react';

export const AgencyPlatformConfig = withHasPerm(function AgencyPlatformConfig(): ReactElement {
  const { endpoint } = useEntity<Enterprise>();

  const url = `${endpoint}platform_config/`;

  return (
    <ItemLoader<any> url={url}>
      {({ mutate, item }) => (
        <UpdateContainer
          url={url}
          initialValues={item}
          updateItem={(value) => {
            mutate(value, { revalidate: false });
          }}
          method="POST"
        >
          <div className="container px-0 ml-0">
            <div className="form-row">
              <IntField name="membership_seat_limit" label="Mebmership seat limit" className="col-2" />
            </div>
          </div>
        </UpdateContainer>
      )}
    </ItemLoader>
  );
}, platformAdmin);
